"use client";

import { useLogAnalyticsEventClient } from "@/firebase/useLogAnalyticsEventClient";
interface EmbedAnalyticsProps {
  videoId: string;
}
export function EmbedAnalytics({
  videoId
}: EmbedAnalyticsProps) {
  useLogAnalyticsEventClient("view-video-embed", {
    videoId
  }, {
    defer: true
  });
  return null;
}